<template>
  <div>
    <anamnesis
      :dataCrud.sync="localDataCrud"
      v-bind="{
        ...schema,
        modelForm,
        handleEvents,
        handleEventsCrud,
        save,
        clickRowInfo,
        remove,
        snackbar,
        overlay,
        overlayMessage,
        toggleOverlay,
        status,
      }"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Anamnesis from '@/components/includes/Anamnesis';

export default {
  name: 'filiationPersonalPage',
  components: { Anamnesis },

  data: () => ({
    menu: false,
    modal: false,
    menu2: false,
    overlay: false,
    overlayMessage: '',
    filiationInformantId: null,
    localDataCrud: [],     
  }),

  watch: {
    dataCrud: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.localDataCrud = JSON.parse(JSON.stringify(newValue));
        }
      }
    }
  },

  computed: {
    ...mapGetters('anamFiliationPersonal', [
      'schema',
      'modelForm',
      'dataCrud',
      'isNewRecord',
      'status',
    ]),
    ...mapGetters('anamPermissions', ['hasPermission']),
    ...mapGetters('proProfileAPage', ['catDepartments']),
    ...mapGetters('proProfileAPage', ['catProvinces']),
    ...mapGetters('proProfileAPage', ['catDistricts']),
    ...mapGetters('notifications', ['snackbar']),
  },

  mounted() {
    this.loadData();
    this.loadCatDepartments();
    this.loadCatProvinces();
    this.loadCatDistricts();
  },

  methods: {
    ...mapActions('anamFiliationPersonal', [
      'fetchSchema',
      'fetchRecords',
      'createRecord',
      'updateRecord',
      'removeRecord',
    ]),
    ...mapActions('proProfileAPage', ['loadCatDepartments']),
    ...mapActions('proProfileAPage', ['loadCatProvinces']),
    ...mapActions('proProfileAPage', ['loadCatDistricts']),
    ...mapActions('anamPermissions', ['sectionsHCPandRoute', 'checkPermission']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        await Promise.all([
          this.fetchSchema(),
          this.sectionsHCPandRoute(this.$route),
        ]);

        if (this.hasPermission) {
          await this.fetchRecords();
        } else {
          this.overlay = true;
          this.overlayMessage = 'No tiene acceso a esta sección. Solicite permisos.';
        }
      } catch (error) {
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    toggleOverlay() {
      this.overlay = !this.overlay;
      if (!this.overlay && this.$route.name !== 'index') {
        this.$router.replace({ name: 'index' });
      }
    },

    handleEvents(val) {
      this.val = val;
      this.ubigeo();
    },

    clickRowInfo(clickItem) {
      this.filiationInformantId = clickItem?.filiation_informant_id ?? null;
    },

    ubigeo() {
      const filiationCountry = this.val?.data?.filiation_residence_iso3366;

      if (!filiationCountry) return;

      if (filiationCountry === 'PE') {
        this.schema.schemaForm.group1.schema.filiation_residence_department.items =
          this.catDepartments;
      } else if (filiationCountry !== 'PE') {
        this.schema.schemaForm.group1.schema.filiation_residence_department.items = [
          { departments_id: '999999', departments: '---' },
        ];
        this.modelForm.group1.filiation_residence_department = '999999';
      }
    },

    handleEventsCrud() {},

    async save() {
      try {
        const hcpDate = this.modelForm.group3.hcp_date;
        if (!hcpDate) {
          alert('Debes seleccionar una fecha');
          return
        }
       
        const model = { modelForm: this.modelForm, dataCrud: this.localDataCrud };
        const action = this.isNewRecord ? 'createRecord' : 'updateRecord';
        
        await this[action]({ model });

        const message =
          this.status === 'success'
            ? this.sanitizeText(this.schema?.snackOk || 'Guardado correctamente.')
            : this.sanitizeText(this.schema?.snackError || 'Error al guardar.');

        this.showSnackbar(message, this.status === 'success' ? 'success' : 'error');

        this.fetchRecords();
        await this.$store.dispatch('anamLineData/loadModelForm');

      } catch (error) {
        console.error('Error al guardar:', error);
        this.showSnackbar(
          this.sanitizeText('La fecha de HCP no puede estar vacía'),
          'error'
        );
        this.fetchRecords();
      }
    },

    async remove() {
      if (!this.filiationInformantId) {
        return this.showSnackbar('No hay un registro seleccionado.', 'warning');
      }

      try {
        await this.removeRecord({ id: this.filiationInformantId });
        this.showSnackbar(
          this.sanitizeText(this.schema?.snackOkRemoved || 'Eliminado correctamente.'),
          'success'
        );      
      } catch (error) {
        console.error('Error al eliminar:', error);
        this.showSnackbar(this.sanitizeText(this.schema.snackError), 'error');
      }

      this.fetchRecords();
    },

    handleDataError(error, message) {
      console.error(message, error);
      this.showSnackbar(message, 'error');
    },

    showSnackbar(content, color) {
      this.triggerSnackbar({ content, color });
    },

    sanitizeText(text) {
      return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
  },
};
</script>
